import React from "react";
import { useTranslation } from "react-i18next";
import FreeShippingPromoBanner from "storefront/components/FreeShippingPromoBanner";
import styles from "./index.module.scss";

export const Footer = () => {
  const { t } = useTranslation("common");

  return (
    <p className={styles.legal}>
      By creating an account, I accept {`${t("MARKETPLACE_NAME")}'s`}{" "}
      <a href="/about/terms" target="_blank" rel="noopener noreferrer">
        Terms of Service
      </a>
      .
      <br />
      For Grailed&apos;s Privacy Policy, click{" "}
      <a href="/about/privacy" target="_blank" rel="noopener noreferrer">
        here
      </a>
      .
    </p>
  );
};

export const Hr = () => <hr className={styles.lineBreak} />;

export const Message = ({ children }: { children: React.ReactNode }) => (
  <p className={styles.message}>{children}</p>
);

export const Error = ({ children }: { children: React.ReactNode }) => (
  <p className={styles.error}>{children}</p>
);

type LayoutProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  showPromo?: boolean;
};

export const Layout = ({ children, title, showPromo = false }: LayoutProps) => (
  <div className={styles.content}>
    {showPromo ? <FreeShippingPromoBanner className={styles.promo} /> : null}
    <div className={styles.header}>
      <h2 id="auth-modal-title" className={styles.headerTitle}>
        {title}
      </h2>
      {showPromo ? (
        <p className={styles.subtitle}>
          Rare archives, new designer releases & vintage gems—all in one place.
          No hidden buyer fees.
        </p>
      ) : null}
    </div>
    <div className={styles.body}>
      <div className={styles.usersAuthentication}>
        <div className={styles.container}>{children}</div>
      </div>
    </div>
  </div>
);
